// Cover image that never crops: portrait/tall images (book covers) render with
// object-fit: contain on a warm cream background; landscape images keep cover.
// Fit is decided once the image loads (natural dimensions); hidden briefly to
// avoid a cropped flash.
import { useState } from "react";

export default function SmartCoverImage({ src, alt, width, height, className = "", style = {}, ...rest }) {
  const [fit, setFit] = useState(null); // null = not loaded yet
  const [failed, setFailed] = useState(false);

  // Missing or broken image → render nothing; the container's solid cream
  // background (#f5f3ef) shows instead. Never substitute a placeholder image.
  if (failed || !src) return null;

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{
        objectFit: fit === "portrait" ? "contain" : "cover",
        backgroundColor: "#faf9f7",
        opacity: fit ? 1 : 0,
        transition: "opacity 200ms ease",
        ...style,
      }}
      onLoad={(e) => {
        const img = e.currentTarget;
        setFit(img.naturalHeight > img.naturalWidth ? "portrait" : "landscape");
      }}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
